import { Box, Flex, rem } from 'affiny-ui/src';
import React, { memo } from 'react';
import { Svg } from '../../svg';
import { Logo } from '../Logo';

export const HEADER_HEIGHT = rem(60);

interface ILayerHeader {
  onClose: () => void;
}

export const LayerHeader = memo(({ onClose }: ILayerHeader) => {
  return (
    <Box
      position="sticky"
      top={0}
      boxShadow="0 15px 15px -15px rgba(0,0,0,0.1)"
      height={HEADER_HEIGHT}
      overflowX="hidden"
      zIndex={103}
      backgroundColor="light"
    >
      <Flex
        height="100%"
        alignItems="center"
        justifyContent="center"
        maxWidth={[720, 960, 1280]}
        px={rem(81)}
        margin="auto"
      >
        <Flex height="100%" alignItems="center" justifyContent="flex-start">
          <Logo isLayer={true} />
        </Flex>
        <Flex height="100%" alignItems="center" justifyContent="flex-end">
          <Box onClick={onClose} cursor="pointer">
            <Svg type="CrossMediumLayer" />
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
});
